import { atom } from 'recoil';

export const selectedWalletPay = atom({
  key: 'selectedWalletPay',
  default: undefined,
});
